require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/fn/get-iterator.js
// module id = 1269
// module chunks = 0